import React from 'react'
import { View, ScrollView, Text } from 'react-native'
import { Stat } from './Stat';
import { Slide } from './Slide';
import { styles } from './styles'
import { Dispute } from './Dispute';
import { ImageDispute } from './ImageDispute';
import { FontAwesome } from '@expo/vector-icons';
import Colors from '../../constants/Colors';

export const Carousel = (props) => {

  const { items, style } = props;
  const itemsPerInterval = props.itemsPerInterval === undefined ? 1 : props.itemsPerInterval;

  const [interval, setInterval] = React.useState(1);
  const [intervals, setIntervals] = React.useState(1);
  const [width, setWidth] = React.useState(0);

   const scrollViewRef = React.useRef(null);

  const init = (width, height) => {
    console.log('Carousel init', width, height);
    // initialise width
    setWidth(width);
    // initialise total intervals
    const totalItems = items.length;
    setIntervals(Math.ceil(totalItems / itemsPerInterval));
  }

  const getInterval = (offset) => {
    for (let i = 1; i <= intervals; i++) {
      if (offset + 1 < (width / intervals) * i) {
        return i;
      }
      if (i == intervals) {
        return i;
      }
    }
  }

  let bullets = [];
  for (let i = 1; i <= intervals; i++) {
    bullets.push(
      <FontAwesome name={interval === i ? 'circle' : 'circle-o'} size={16} color={Colors.lightBlue2} style={{ ...styles.bullet }} key={i} />
    )
  }

  return (
    <ScrollView style={styles.container} ref={scrollViewRef}>
      <ScrollView
        horizontal={true}
        contentContainerStyle={{ ...styles.scrollView, width: `${100 * intervals}%` }}
        showsHorizontalScrollIndicator={false}
        onContentSizeChange={(w, h) => init(w, h)}
        onScroll={data => {
          setWidth(data.nativeEvent.contentSize.width);
          setInterval(getInterval(data.nativeEvent.contentOffset.x));
        }}
        scrollEventThrottle={200}
        pagingEnabled
        decelerationRate="fast"
        onMomentumScrollEnd={(data) => {
          // scrolls to top when paging
          scrollViewRef.current.scrollTo({ y:0, animated: true})
        }}
        // removeClippedSubviews={true}
      >
        {items.map((item, index) => {
          switch (style) {
            case 'stats':
              return (
                <Stat
                  key={index}
                  label={item.label}
                  value={item.value}
                />
              );
            case 'slide':
              return (
                <Slide
                  key={index}
                  title={item.title}
                />
              );
            case 'dispute':
              return (
                <Dispute
                  key={index}
                  intro={item.intro}
                  number={index+1}
                  title={item.title}
                  image={item.image}
                  description={item.description}
                  button={item.button}
                  goTo={item.goTo}
                  navigation={props.navigation}
                />
              )
            case 'imageDispute':
              return (
                <ImageDispute
                  key={index}
                  id={item.id}
                  title={item.title}
                  amount={item.amount}
                  address={item.address}
                  image={item.main_image}
                  navigation={props.navigation}
                />
              )
            default:
              return null;
          }
        })}
      </ScrollView>
      <View style={styles.bullets}>
        {bullets}
      </View>
    </ScrollView>
  )
}

export default Carousel;